import tAuth from './auth'

const authStore: any = {
  tAuth
}

export default authStore
